import Circular from './Circular';

const LoaderExports = {
  Circular,
};
export default LoaderExports;
